const IconDocument = ({ width = 20, height = 20, fill = "#252525" }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.5002 1.66666H5.00016C4.55814 1.66666 4.13421 1.84226 3.82165 2.15482C3.50909 2.46738 3.3335 2.8913 3.3335 3.33333V16.6667C3.3335 17.1087 3.50909 17.5326 3.82165 17.8452C4.13421 18.1577 4.55814 18.3333 5.00016 18.3333H15.0002C15.4422 18.3333 15.8661 18.1577 16.1787 17.8452C16.4912 17.5326 16.6668 17.1087 16.6668 16.6667V5.83333L12.5002 1.66666Z"
        stroke={fill}
        stroke-width="1.66667"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M11.6665 1.66666V5C11.6665 5.44202 11.8421 5.86595 12.1547 6.17851C12.4672 6.49107 12.8911 6.66666 13.3332 6.66666H16.6665"
        stroke={fill}
        stroke-width="1.66667"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M8.33317 7.5H6.6665"
        stroke={fill}
        stroke-width="1.66667"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M13.3332 10.8333H6.6665"
        stroke={fill}
        stroke-width="1.66667"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M13.3332 14.1667H6.6665"
        stroke={fill}
        stroke-width="1.66667"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export default IconDocument;
